export const fontsMarckScript = [
  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/MarckScript-Regular.ttf",
      },
    ],
    weight: "400",
  },
];
